import angular from 'angular';
import appSettingsModule from '../app.settings.module';

import InviteService from './userinvite.service';
import TransferService from './transfers.service';
import SavedSearchService from './savedsearch.service';
import SecurityGroupsService from './securitygroups.service';
import SavedFilterService from './savedfilter.service';
import RoundingService from './rounding.service';
import ReportsRepository from './reports.service';
import PhotoSwipeService from './photoSwipe.service';
import PackagesService from './packages.service';
import MobileService from './mobile.service';
import MarkdownService from './markdown.service';
import NavService from './nav/nav.service';
import loadingModalService from './loading.modal.service';
import LanguagesService from './languages.service';
import InstallationNoteService from './installation.note.service';
import FileUploaderService from './fileUploader.service';
import DevicesService from './devices.service';
import {exceptionHandlerProvider, ExceptionLoggingService} from './client.side.error.logging.service';
import AttrsTranslateService from './attr.translate.service';
import AppNotificationsService from './app.notifications.service';
import AlertRuleService from './alert.rules.service';
import EquipmentSearchService from '../equipment/services/equipment-search.service';
import TagsService from './attrs-tags.service';
import AttributesService from './attributes.service';
import DeviceDiagnosticService from './device-diagnostic.service';

const serviceModule = angular.module('app.service', [appSettingsModule]);

serviceModule
  // Controllers
  .service('alertRuleService', AlertRuleService)
  .service('appNotificationsService', AppNotificationsService)
  .service('attrsTranslateService', AttrsTranslateService)
  /**
   * Exception Logging Service, currently only used by the $exceptionHandler
   * it preserves the default behaviour ( logging to the console) but
   * also posts the error server side after generating a stacktrace.
   */
  .factory('exceptionLoggingService', ExceptionLoggingService)
  /**
   * Override Angular's built in exception handler, and tell it to
   * use our new exceptionLoggingService which is defined below
   */
  .provider('$exceptionHandler', exceptionHandlerProvider)
  .factory('devicesService', DevicesService)
  .service('fileUploaderService', FileUploaderService)
  .service('installationNoteService', InstallationNoteService)
  .service('languagesService', LanguagesService)
  .service('loadingModalService', loadingModalService)
  .service('markdownService', MarkdownService)
  .factory('mobileService', MobileService)
  .service('navService', NavService)
  .factory('packagesService', PackagesService)
  .service('photoSwipeService', PhotoSwipeService)
  .service('reportsRepository', ReportsRepository)
  .service('roundingService', RoundingService)
  .factory('savedFilterService', SavedFilterService)
  .factory('savedSearchService', SavedSearchService)
  .service('securityGroupsService', SecurityGroupsService)
  .service('transfersService', TransferService)
  .service('inviteService', InviteService)
  .service('equipmentSearchService', EquipmentSearchService)
  .service('tagsService', TagsService)
  .service('attributesService', AttributesService)
  .service('deviceDiagnosticService', DeviceDiagnosticService);

export default serviceModule.name;
